'use client'

import { useReportWebVitals } from 'next/web-vitals'

export function WebVitals() {
  useReportWebVitals((metric) => {
    // In development, log all Web Vitals to the console
    if (process.env.NODE_ENV === 'development') {
      console.log(`[Web Vitals] ${metric.name}:`, {
        value: metric.value,
        rating: metric.rating,
        delta: metric.delta,
        id: metric.id,
      })
      return
    }

    // In production, log to console for now.
    // Future: send to CloudWatch via an API route.
    console.log(`[Web Vitals] ${metric.name}: ${metric.value} (${metric.rating})`)
  })

  return null
}
